// import C7Init from "./commerce7/c7";
import Modules from "./modules/modules";

// new C7Init().init();
new Modules().init();

jQuery(document).ready(function ($) {

    /* Smooth anchor scroll */
    $(document).on("click", 'a[href^="#"]', function (e) {
        e.preventDefault();
        const href = $(this).attr('href')
        if (href.length > 1 && $(href) && !$(this).hasClass('view-cart')) {
            $("html, body").animate(
                {
                    scrollTop: $(href).offset().top,
                },
                500
            );
        }
    });

    /* mobile hamburger menu click */
    $("#menu-btn").change(function () {
        if (this.checked) {
            setTimeout(function () { $('header').siblings().addClass('d-none'); }, 500);
            setTimeout(function () { $('header').parents().siblings().addClass('d-none'); }, 500);
            $('body').css('overflow-x', 'visible');
            $('html').css('overflow-x', 'visible');
            $('.announcement_bar').removeClass('d-none');
            $('header').addClass('h-open');
            $('.main-menu').slideDown(500);
        }
        else {
            $('.main-menu').slideUp(500);
            $('header').siblings().removeClass('d-none');
            $('header').parents().siblings().removeClass('d-none');
            $('body').css('overflow-x', 'hidden');
            $('html').css('overflow-x', 'hidden');
            $('header').removeClass('h-open');
        }
    });

    /* mobile has sub menu click */
    $(document).on("click", 'header .header-right .main-menu .menu-item.has-sub-menu .icon-caret', function (e) {
        e.preventDefault();
        $(this).toggleClass("opened");
        // $(this).closest('.has-sub-menu').find(".sub-menu-container").toggleClass( "opened" );
        $(this).closest('.has-sub-menu').find(".sub-menu-container").slideToggle();
        $(this).closest('.has-sub-menu').find(".main-menu-link").toggleClass("opened");
    });

    $(document).on("click", 'footer .footer__main .footer__menu .menu-item .icon-caret', function (e) {
        e.preventDefault();
        $(this).toggleClass("opened");
        $(this).closest('.has-sub-menu').find(".sub-menu-container").toggleClass("opened");
        $(this).closest('.has-sub-menu').find(".sub-menu-container").slideToggle();
    });

    $(document).on("click", '.hwy__nav-bar .nav-links-wrapper .title-container .icon-caret', function (e) {
        e.preventDefault();
        $(this).toggleClass("opened");
        $(this).closest('.nav-links-wrapper').find(".links-container").slideToggle();
    });

    $(document).on("click", '.hwy__nav-bar .nav-links-wrapper .title-container .nav-title', function (e) {
        e.preventDefault();
        $('.hwy__nav-bar .nav-links-wrapper .title-container .icon-caret').toggleClass("opened");
        $(this).closest('.nav-links-wrapper').find(".links-container").slideToggle();
    });

    /* cart icon click */
    $(document).on("click", ".icon-cart", function () {
        $('section.c7-cart').addClass('c7-visible')
    });

    /* close cart icon click */
    $(document).on("click", ".c7-cart__close", function () {
        $('section.c7-cart').removeClass('c7-visible')
    });


    /* main menu trigger window size change */
    var is_desktop = window.innerWidth > 1024;
    window.onresize = function () {
        var current_mode = window.innerWidth > 1024;
        if (current_mode && !is_desktop) {
            $('.main-menu').css("display", "flex");
            $('header').siblings().removeClass('d-none');
            $('header').parents().siblings().removeClass('d-none');
            $('header').removeClass('h-open');
            $('body').css('overflow-x', 'hidden');
            $('html').css('overflow-x', 'hidden');
            is_desktop = !is_desktop;
        }
        else if (!current_mode && is_desktop) {
            $('.main-menu').css("display", "none");
            $('#menu-btn').attr('checked', false);
            $('#menu-btn').prop('checked', false);
            is_desktop = !is_desktop;
        }

        var w = $(window).width();
        if (w > 768 && $('footer .footer__main .footer__menu .menu-item .sub-menu-container').is(':hidden')) {
            $('footer .footer__main .footer__menu .menu-item .sub-menu-container').removeAttr('style');
            $('footer .footer__main .footer__menu .menu-item .icon-caret').removeClass('opened');
        }

        if (w > 1024) {
            $('header .header-right .main-menu .menu-item .sub-menu-container').removeAttr('style');
            $('header .header-right .main-menu .menu-item .main-menu-link').removeClass('opened');
            $('header .header-right .main-menu .menu-item.has-sub-menu .icon-caret').removeClass('opened');

            $('.hwy__nav-bar .nav-links-wrapper .links-container').removeAttr('style');
            $('.hwy__nav-bar .nav-links-wrapper .title-container .icon-caret').removeClass('opened');
        }
    }


    /* ajax read more request */
    $('#recipe-load-more').click(function () {
        var counts = Number($('#show-counts').text());
        var row = Number($('#row').val());
        var all_count = Number($('#all').val());
        var show_all = Number($('#show-all').val());
        var post_ids = $('#post-ids').val();
        row = row + 9;

        if (row <= all_count) {
            $("#row").val(row);

            $.ajax({
                url: '/wp-admin/admin-ajax.php',
                type: 'post',
                data: 'action=recipe_ajax_load_more&row=' + row + '&all_count=' + all_count + '&show_all=' + show_all + '&post_ids=' + post_ids,
                beforeSend: function () {
                    $("#load-more").text("Loading...");
                },
                success: function (response) {

                    // Setting little delay while displaying new content
                    setTimeout(function () {
                        // appending posts after last post with class="post"
                        $(".recipe:last").after(response).show().fadeIn("slow");

                        var rowno = row + 9;
                        counts = counts + 9;


                        if (counts > all_count) {
                            $('#show-counts').text(all_count);
                        } else {
                            $('#show-counts').text(counts);
                        }

                        // checking row value is greater than all count or not
                        if (rowno > all_count) {

                            // Change the text and background
                            $('#recipe-load-more').css("display", "none");
                        } else {
                            $("#recipe-load-more").text("Load more");
                        }
                    }, 1000);

                }
            });
        }

    });

    $('#article-load-more').click(function () {
        var counts = Number($('#show-counts').text());
        var row = Number($('#row').val());
        var all_count = Number($('#all').val());
        var show_all = Number($('#show-all').val());
        var post_ids = $('#post-ids').val();
        row = row + 9;

        if (row <= all_count) {
            $("#row").val(row);

            $.ajax({
                url: '/wp-admin/admin-ajax.php',
                type: 'post',
                data: 'action=article_ajax_load_more&row=' + row + '&all_count=' + all_count + '&show_all=' + show_all + '&post_ids=' + post_ids,
                beforeSend: function () {
                    $("#article-load-more").text("Loading...");
                },
                success: function (response) {

                    // Setting little delay while displaying new content
                    setTimeout(function () {
                        // appending posts after last post with class="post"
                        $(".article:last").after(response).show().fadeIn("slow");

                        var rowno = row + 9;
                        counts = counts + 9;


                        if (counts > all_count) {
                            $('#show-counts').text(all_count);
                        } else {
                            $('#show-counts').text(counts);
                        }

                        // checking row value is greater than all count or not
                        if (rowno > all_count) {

                            // Change the text and background
                            $('#article-load-more').css("display", "none");
                        } else {
                            $("#article-load-more").text("Load more");
                        }
                    }, 1000);

                }
            });
        }

    });

    /* sticky add to cart */

    $(document).bind('scroll', function () {
        if ($('.c7-single-product .c7-product-detail .c7-product__info .c7-product__add-to-cart .c7-product__add-to-cart__form').length) {
            const sticky = $('.c7-single-product .c7-product-detail .c7-product__info .c7-product__add-to-cart .c7-product__add-to-cart__form').offset();

            if ($(document).scrollTop() > sticky.top) {
                $('.sticky-add-to-cart-inner').addClass('fixed');
            } if ($(document).scrollTop() <= sticky.top) {
                $('.sticky-add-to-cart-inner').removeClass('fixed');
            }
        }

        if ($('#nav-bar-block.enable-sticky').length) {
            const sticky_nav_bar = $('#nav-bar-block').offset();

            if ($(document).scrollTop() > sticky_nav_bar.top) {
                $('.nav-bar-inner ').addClass('fixed');
            } if ($(document).scrollTop() <= sticky_nav_bar.top) {
                $('.nav-bar-inner ').removeClass('fixed');
            }
        }
    });

    /* add Retail price in single product page */
    let retail = setInterval(function () {
        if ($('.c7-product__info .c7-product__add-to-cart .c7-product__add-to-cart__price').length) {
            clearInterval(retail);
            $('.c7-product__info .c7-product__add-to-cart .c7-product__add-to-cart__price .c7-product__add-to-cart__price__compare').append(" Retail");
            $('.c7-product__info .c7-product__add-to-cart .c7-product__add-to-cart__price .c7-product__add-to-cart__price__sale').append(" Your Price");
        }
    }, 100);

    /* load more wines in collection page */
    let wines = setInterval(function () {
        if ($('.hwy__c7-collection .c7-product-collection .c7-product-collection__products').length) {
            clearInterval(wines);
            let all_wine_counts = $('.hwy__c7-collection .c7-product-collection .c7-product-collection__products .c7-product').length;
            let current_wine_counts;

            if (all_wine_counts <= 9) {
                current_wine_counts = all_wine_counts;
                $(".hwy__c7-collection .info-container #wine-load-more").css("display", "none");
            } else {
                current_wine_counts = 9;
            }

            $(".hwy__c7-collection .c7-product-collection .c7-product-collection__products .c7-product:lt(" + current_wine_counts + ")").css("display", "flex");
            $(".hwy__c7-collection .info-container .wine-counts-container .wine-current-counts #show-counts").text(current_wine_counts);
            $(".hwy__c7-collection .info-container .wine-counts-container .wine-all-counts #all-counts").text(all_wine_counts);
            $(".hwy__c7-collection .info-container #wine-currents-value").val(current_wine_counts);
            $(".hwy__c7-collection .info-container #wine-all-value").val(all_wine_counts);
        }
    }, 100);

    $(document).on("click", '.hwy__c7-collection .info-container #wine-load-more', function (e) {
        e.preventDefault();

        let current_wine_counts = Number($(".hwy__c7-collection .info-container #wine-currents-value").val());
        let all_wine_counts = Number($(".hwy__c7-collection .info-container #wine-all-value").val());

        current_wine_counts = current_wine_counts + 9;

        if (all_wine_counts > current_wine_counts) {
            $(".hwy__c7-collection .c7-product-collection .c7-product-collection__products .c7-product:lt(" + current_wine_counts + ")").css("display", "flex");
            $(".hwy__c7-collection .info-container .wine-counts-container .wine-current-counts #show-counts").text(current_wine_counts);
            $(".hwy__c7-collection .info-container #wine-currents-value").val(current_wine_counts);
        } else {
            $(".hwy__c7-collection .c7-product-collection .c7-product-collection__products .c7-product:lt(" + all_wine_counts + ")").css("display", "flex");
            $(".hwy__c7-collection .info-container .wine-counts-container .wine-current-counts #show-counts").text(all_wine_counts);
            $(".hwy__c7-collection .info-container #wine-currents-value").val(all_wine_counts);
            $(".hwy__c7-collection .info-container #wine-load-more").css("display", "none");
        }
    });

    /* chat bot link */
    if ($('#contact-chat').length) {
        $(document).on("click", '#contact-chat', function (e) {
            e.preventDefault();
            LiveChatWidget.call('maximize');
            return false;
        });
    }

    $(document).on("click", '.tasting__booking .tasting__booking_btn', function (e) {
        e.preventDefault();
        let $this = $(this);
        $this.closest(".tasting__booking").find(".tasting__booking_popup").fadeIn();
    });

    $(document).on("click", '.tasting__booking__close', function (e) {
        e.preventDefault();
        let $this = $(this);
        $this.closest(".tasting__booking").find(".tasting__booking_popup").fadeOut();
    });


});